import React from 'react';
import ErrorLayout from '../../components/ErrorLayout';

const Forbidden = () => (
  <ErrorLayout 
    code={403} 
    title="Access Forbidden" 
    message="You do not have the necessary permissions to view this resource." 
    icon="pi pi-ban" 
    color="#e67e22" 
  />
);
export default Forbidden;